export const RPU_CREATION_REDUCER = (state = null, action) =>{
    if(action.type === 'RPU_CREATION_ACTION'){
        return action.payload;
    }
    return state;
};